import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Select from "react-select";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { InventarioOtrosAcopiosApi } from "../api/InventarioOtrosAcopiosApi";
import { AlmacenesConsultaTable } from "./AlmacenesConsultaTable";
const refreshIcon = require("assets/img/icons/refresh.png");

export const ConsultaInventarioAcopio = ({ storageKey }) => {
    const { getAcopiosConsultables, getUltimoInventario, cargando } =
        InventarioOtrosAcopiosApi();

    const [acopios, setAcopios] = useState([]);
    const [acopioSeleccionado, setAcopioSeleccionado] = useState(null);
    const [consulta, setConsulta] = useState(null);

    // El acopio consultado se resuelve contra el listado y no desde
    // sessionStorage, para no arrastrar uno que ya se desactivó o cambió de
    // nombre. Con un solo acopio disponible se selecciona solo
    const GetAcopiosConsultables = async () => {
        try {
            const response = await getAcopiosConsultables();
            const disponibles = response || [];

            setAcopios(disponibles);

            const idGuardado = Number(sessionStorage.getItem(storageKey));

            const guardado = disponibles.find(
                (acopio) => acopio.id === idGuardado,
            );

            if (guardado) {
                setAcopioSeleccionado(guardado);
            } else if (disponibles.length === 1) {
                setAcopioSeleccionado(disponibles[0]);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los acopios disponibles",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setAcopios([]);
        }
    };

    useEffect(() => {
        GetAcopiosConsultables();
    }, []);

    // Cambiar de acopio dispara una consulta nueva: se descarta la respuesta de
    // la anterior si llega tarde, y se limpia lo que está en pantalla de una vez
    // para no mostrar el inventario de un acopio bajo el nombre de otro
    const consultaVigente = useRef(0);

    const GetUltimoInventario = async (acopio) => {
        const consultaActual = consultaVigente.current + 1;
        consultaVigente.current = consultaActual;

        setConsulta(null);

        if (!acopio) return;

        try {
            const response = await getUltimoInventario(acopio.id);

            if (consultaVigente.current !== consultaActual) return;

            setConsulta(response);
        } catch (error) {
            if (consultaVigente.current !== consultaActual) return;

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el inventario del acopio",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetUltimoInventario(acopioSeleccionado);
    }, [acopioSeleccionado]);

    const SeleccionarAcopio = (acopio) => {
        setAcopioSeleccionado(acopio);

        if (acopio) {
            sessionStorage.setItem(storageKey, acopio.id);
        } else {
            sessionStorage.removeItem(storageKey);
        }
    };

    const inventario = consulta ? consulta.inventario : null;

    return (
        <div className="inventario-otros-acopios__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={cargando} blur>
                    <div className="inventario-otros-acopios__table-header">
                        <div className="mr-auto formulario-fields-row">
                            <div className="formulario-field inventario-otros-acopios__acopio-field">
                                <label htmlFor="acopio" className="m-0">
                                    Acopio
                                </label>
                                <Select
                                    inputId="acopio"
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    options={acopios}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nombre}
                                    value={acopioSeleccionado}
                                    onChange={SeleccionarAcopio}
                                    placeholder="Seleccione un acopio"
                                    noOptionsMessage={() =>
                                        "No hay otros acopios"
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 20,
                                        }),
                                    }}
                                />
                            </div>
                            <img
                                src={refreshIcon}
                                alt="Refrescar consulta"
                                title="Refrescar consulta"
                                className="action_img mb-1 mt-auto"
                                onClick={() =>
                                    GetUltimoInventario(acopioSeleccionado)
                                }
                            />
                        </div>

                        {inventario && (
                            <div
                                className="ml-auto formulario-fields-row"
                                style={{ gap: "1rem" }}
                            >
                                <div
                                    className="formulario-field"
                                    style={{ minWidth: "210px" }}
                                >
                                    <label htmlFor="periodo" className="m-0">
                                        Periodo del inventario
                                    </label>
                                    <input
                                        type="text"
                                        id="periodo"
                                        className="form-control"
                                        value={inventario.periodo}
                                        disabled
                                    />
                                </div>
                                <div
                                    className="formulario-field"
                                    style={{ minWidth: "180px" }}
                                >
                                    <label htmlFor="estado" className="m-0">
                                        Estado
                                    </label>
                                    <input
                                        type="text"
                                        id="estado"
                                        className="form-control"
                                        value={TextoEstadoInventario(
                                            inventario,
                                        )}
                                        disabled
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {!acopioSeleccionado && (
                        <div className="text-center my-5">
                            Seleccione un acopio para ver cómo va su inventario.
                        </div>
                    )}

                    {acopioSeleccionado && consulta && !inventario && (
                        <div className="text-center my-5">
                            {consulta.detail}
                        </div>
                    )}

                    {inventario && (
                        <AlmacenesConsultaTable
                            almacenes={inventario.almacenes}
                            categoriaAcopio={consulta.acopio.categoria}
                        />
                    )}
                </LoadMask>
            </CardEmpty>
        </div>
    );
};

// Un inventario abierto sigue cambiando; uno cerrado quedó fijo en su fecha de
// cierre, y eso es lo que le dice a quien consulta qué tan actual es el dato
const TextoEstadoInventario = (inventario) => {
    if (inventario.estado !== "CERRADO") return "Abierto";

    if (!inventario.fecha_cierre) return "Cerrado";

    return `Cerrado el ${moment(inventario.fecha_cierre).format("DD/MM/YYYY")}`;
};
